import { graphql } from 'gatsby'
import React from 'react'
import Collection from '../containers/Collection'

/**
 * Tag pages (/c/*) are thin listing pages with no unique value: 13 of them
 * carry 65-127 words each. Keep them crawlable for users and link equity, but
 * out of the index. They are also excluded from sitemap.xml.
 */
const CollectionTag = props =>
  React.createElement(Collection, Object.assign({}, props, { noindex: true }))

export default CollectionTag

export const pageQuery = graphql`
  query allArticleByTagQuery(
    $skip: Int!
    $limit: Int!
    $slug: String!
    $includeExcerpt: Boolean!
    $includeTimeToRead: Boolean!
    $imageQuality: Int!
  ) {
    collectionInfo: articleTag(slug: { eq: $slug }) {
      id
      name
      slug
    }

    posts: allArticle(
      filter: {
        private: { ne: true }
        draft: { ne: true }
        tags: { elemMatch: { slug: { eq: $slug } } }
      }
      sort: { fields: [date], order: DESC }
      limit: $limit
      skip: $skip
    ) {
      nodes {
        ...ArticlePreview
        ...ArticleThumbnailRegular
      }
      ...ArticlePagination
    }
  }
`
